import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Message } from '../Message';
import { PageTitle } from '../PageTitle';
import MonitoringGroupingList from './monitoring_grouping_list';
import i18next from "i18next";

const MonitoringLocations = ({ location, history }) => {
  const [localErrorMessage, setLocalErrorMessage] = useState(null);
  const [localSuccessMessage, setLocalSuccessMessage] = useState(localStorage.getItem("global_success_message") ? localStorage.getItem("global_success_message") : location.state?.successMessage);

  const messageDismissCallback = () => {
    localStorage.removeItem('global_success_message');
    setLocalErrorMessage(null);
    setLocalSuccessMessage(null);
  };

  return (
      <div className="animated fadeIn">
          <div className="row">
              {(localErrorMessage || localSuccessMessage) && (
                  <Message
                      messages={location.state ? location : { state: { successMessage: localSuccessMessage } }}
                      errorMessage={localErrorMessage}
                      messageDismissCallback={messageDismissCallback}
                  />
              )}
              <PageTitle title={i18next.t("pages.locations.header")} />
          </div>
          <div className="op-content-box monitoring-location-map">
              <MonitoringGroupingList
                  history={history}
                  localErrorHandler={setLocalErrorMessage}
                  currLocation={history.location}
                  currSearch={location.search}
                  pushHistory={(params) => history.push(params)}
              />
          </div>
      </div>
  );
}

export default connect(({ currentGrouping }) => ({ currentGrouping: currentGrouping.currentGrouping }))(MonitoringLocations);
